import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Le défilement est géré par l'application (retour en haut à chaque page): le navigateur ne doit pas le restaurer
// au rechargement, car les pages se remplissent après coup et la position restaurée ne correspondrait plus à rien.
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
